var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-form',[_c('b-button',{staticClass:"my-2 my-sm-0",attrs:{"size":"sm","variant":"kag-grey"},on:{"click":_vm.logout}},[_vm._v(_vm._s(_vm.isAuthenticated ? 'Sign-Out' : 'Sign-In'))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }